/**
 * AUTO-GENERATED FILE, DO NOT EDIT!
 * =================================
 * This file is automatically generated through the Figma API. If you want to
 * add or update these tokens, let the DS team know through a Jira ticket.
 * Manual additions will be automatically overwritten.
 */

import classNames from 'classnames';

import type { IconProps } from '../types';

type IconPropsExtended = IconProps;

export const EllipsisHorizontalIcon = ({
  className,
  ...otherProps
}: IconPropsExtended): JSX.Element => (
  <svg
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-label="EllipsisHorizontalIcon"
    role="img"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    className={classNames('cogs-icon', className)}
    {...otherProps}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.5 8a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m5 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
      clipRule="evenodd"
    />
  </svg>
);
